import React from 'react';

import { TreeCrumbs } from 'components/common/TreeCrumbs/TreeCrumbs';

import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/CreateReportFromTemplateForm.module.scss';
import { UseCreateReportFromTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.logic';
import { UseCreateReportFromTemplateModalProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.provider';

interface Props {
    logic: UseCreateReportFromTemplateModalLogic['logic'];
    api: UseCreateReportFromTemplateModalProvider['api'];
}

export const ProjectContractSelection = ({ logic, api }: Props) => {
    return (
        <div className={classes.formField}>
            <label>Initial report schedule:</label>
            {logic.contract && api.getProgramGeneralHierrarchyList.isSuccess && (
                <TreeCrumbs
                    selectedNode={logic.contract.uuid}
                    data={api.getProgramGeneralHierrarchyList.data}
                    onSelectionFinish={logic.onSelectionFinish}
                />
            )}
        </div>
    );
};
